/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 导入类型声明
 */
import type { BridgeResponseCallback } from '../../types';

/**
 * 关闭webview方法
 */
export const closeWebView = (): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    window.close();
    return;
  }

  bridgeCallHandler('closeWebView', 'back', null);
};

/**
 * 获取资讯菜单列表
 */
export const getNewsTabList = (callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('getNewsTabList', 'getNewsTabList');
    return;
  }

  bridgeCallHandler('getNewsTabList', '', callback);
};

/**
 * 获取用户信息
 * @param callback
 * @returns
 */
export const getUserInfo = (callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('getUserInfo', 'getUserInfo');
    return;
  }

  bridgeCallHandler('getUserInfo', '', callback);
};

/**
 * 打开微信
 */
export const openWeChat = (): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openWeChat', 'openWeChat');
    return;
  }

  bridgeCallHandler('openWeChat', '', null);
};

/**
 * 获取设备唯一标识
 * @param callback
 * @returns
 */
export const getLocalUuid = (callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('getLocalUuid', 'getLocalUuid');
    return;
  }

  bridgeCallHandler('getLocalUuid', '', callback);
};

/**
 * 获取app版本号
 * @param callback
 * @returns
 */
export const getAppVersion = (callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('getAppVersion', 'getAppVersion');
    return;
  }

  bridgeCallHandler('getAppVersion', '', callback);
};

/**
 * 调用客户端注销登录后退出登录
 */
export const exitApp = (): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('exitApp', 'exitApp');
    return;
  }
  bridgeCallHandler('exitApp', '', null);
};

/**
 * 退出登录
 * 3.10.3版本开始支持 -2026-1-16
 * @param isBack 0返回首页，1返回登录之前的页面
 */
export const logOut = (isBack?: 0 | 1): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('logOut', 'logOut');
    return;
  }
  const value: string = isBack?.toString() || '0';
  bridgeCallHandler('logOut', value, null);
};

/**
 * 获取原生存储数据
 * @param key
 * @param callback
 */
export const getMobileSenorsOptions = (callback: (data: any) => void): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('getMobileSenorsOptions', 'getMobileSensors');
    return;
  }

  bridgeCallHandler('getMobileSensors', '', callback);
};

/*
 * 打开登录页面
 * --2025.08.05 新增
 * @param isBack 0返回首页，1返回登录之前的页面
 */
export const openLoginPage = (isBack?: 0 | 1): void => {
  if (!isInApp()) {
    printNativeMethodFallback('openLoginPage', 'openLoginPage');
    return;
  }
  const data = { isBackCurrentPage: isBack?.toString() || '0' };
  bridgeCallHandler('openLoginPage', JSON.stringify(data), null);
};

/*
 * 打开登录页面-资讯（避雷宝&异动宝）-安卓专用
 * --2026.01.16 新增
 * 安卓在该方法和openLoginPage方法处理方式不一样，防止影响老方法openLoginPage，单独加的方法
 */
export const newOpenLoginPage = (): void => {
  if (!isInApp()) {
    printNativeMethodFallback('newOpenLoginPage', 'newOpenLoginPage');
    return;
  }
  bridgeCallHandler('newOpenLoginPage', '', null);
};
